<template>
    <!-- 首行缩进设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="缩进(字符)"> 
      <el-input-number v-model.number="indent" 
                       class="setting-render_indent"
                       controls-position="right"
                       placeholder="请输入缩进字符数量"
                       :min="0" 
                       :max="50"></el-input-number>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入设置项通用混入文件
// import mixSetting
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 首行缩进
     *  @description 将 indent 字段映射到当前 indent 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      indent: { 
        parent: i => i.renderOption,
        attr: "indent" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderIndent.vue